import React from "react";
import { Navigate } from "react-router-dom";
import { MenuAccess } from "../utils/menuOptions";
import useAuth from "../hooks/useAuth";
import { LoginResponseDocumentation } from "../types/enums";

interface IAuthorizedRoute {
	menuAccesses: MenuAccess | MenuAccess[];
	component: JSX.Element;
}

const AuthorizedRoute = ({ menuAccesses, component }: IAuthorizedRoute) => {
	const { isLoggedIn, menuOptions } = useAuth();
	if (!isLoggedIn) {
		return <Navigate to={"/login"} replace />;
	}
	if (
		(typeof menuAccesses === "string" &&
			!menuOptions?.includes(menuAccesses)) ||
		(Array.isArray(menuAccesses) &&
			!menuOptions?.some((m: any) => menuAccesses.includes(m)))
	) {
		return <Navigate to={"/no-access"} replace />;
	}

	const reqDoc = localStorage.getItem("requiresDocumentation");
	if (reqDoc === "true") {
		return <Navigate to={"/user-document-restore"} replace />;
	}
	return component;
};

export default AuthorizedRoute;
